import { css } from '@rxdi/lit-html';
import { MainView } from '@shared/styles/margin-top';

export const style = css`
  ${MainView}
  .content {
    text-align: center;
  }
  .ide {
    max-width: 1400px;
    margin: 60px auto;
    margin-top: 0px;
    padding: 50px;
  }
  .container {
    margin: 60px auto;
    margin-bottom: 0px;
  }

  .content {
    margin-top: 60px;
  }

  .box {
    background-color: white;
    color: black;
    padding: 30px;
    width: 300px;
    margin-right: 20px;
    box-shadow: 0 5px 55px rgba(162, 162, 162, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  }

  .iframe {
    box-shadow: 0 5px 55px rgba(162, 162, 162, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    margin: 0 auto;
    max-width: 1400px;
  }
  h1 {
    font-size: 2em;
    font-weight: bold;
  }

  .pointer {
    cursor: pointer;
  }
`;
